@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6 text-slate-800 m-4">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold">{{ (reward() ? 'modals.rewardForm.titleEdit' : 'modals.rewardForm.titleAdd') | translate }}</h2>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600" title="Close modal">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      <form [formGroup]="rewardForm" (ngSubmit)="onSave()" class="max-h-[80vh] overflow-y-auto pr-2 -mr-2">
        <div class="space-y-4">
          
          <div>
            <label for="rewardName" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.name' | translate }}</label>
            <input id="rewardName" type="text" formControlName="name" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
              <label for="rewardSku" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.sku' | translate }}</label>
              <input id="rewardSku" type="text" formControlName="sku" [placeholder]="'modals.rewardForm.skuPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
            <div>
              <label for="rewardTag" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.tag' | translate }}</label>
              <input id="rewardTag" type="text" formControlName="tag" [placeholder]="'modals.rewardForm.tagPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
              <label for="rewardPoints" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.points' | translate }}</label>
              <input id="rewardPoints" type="number" formControlName="points_required" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
            <div>
              <label for="rewardCost" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.cost' | translate }}</label>
               <div class="relative mt-1">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span class="text-gray-500 sm:text-sm">฿</span>
                </div>
                <input id="rewardCost" type="number" formControlName="cost" class="block w-full rounded-md border-gray-300 pl-7 pr-3 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm">
              </div>
            </div>
          </div>

          <div>
              <label for="rewardMonthlyLimit" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.limit' | translate }}</label>
              <input id="rewardMonthlyLimit" type="number" formControlName="monthly_limit" [placeholder]="'modals.rewardForm.limitPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
          </div>
          
           <div>
            <label for="rewardImageUrl" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.imageUrl' | translate }}</label>
            <input id="rewardImageUrl" type="url" formControlName="imageUrl" [placeholder]="'modals.rewardForm.imageUrlPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
          </div>

          <div>
            <label for="rewardDescription" class="block text-sm font-medium text-gray-700">{{ 'modals.rewardForm.description' | translate }}</label>
            <textarea id="rewardDescription" formControlName="description" rows="3" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"></textarea>
          </div>

          <div>
             <label class="block text-sm font-medium text-gray-700">{{ 'modals.productForm.status' | translate }}</label>
              <div class="mt-2 flex items-center">
                 <input formControlName="active" id="rewardActive" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500">
                 <label for="rewardActive" class="ml-2 block text-sm text-gray-900">{{ 'modals.rewardForm.statusLabel' | translate }}</label>
              </div>
          </div>

        </div>

        <div class="mt-8 flex justify-end space-x-3">
          <button type="button" (click)="onClose()" class="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 font-semibold transition-colors">{{ 'modals.productForm.cancel' | translate }}</button>
          <button type="submit" [disabled]="rewardForm.invalid" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 disabled:bg-emerald-300 font-semibold transition-colors">{{ 'modals.productForm.save' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
}
